module.exports = __webpack_public_path__ + "img/video-placeholder.0bce9558.jpg";